import React, { useCallback, useEffect } from "react";
import * as Yup from "yup";
import {
  TrainerEditContent,
  ProfilePicture,
  WodEditContent,
  MembersInfoEdit,
} from "../../contents/htmlContent";
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Row,
  Col,
  Modal,
  ModalBody,
  Input,
  FormGroup,
  Label,
} from "reactstrap";
import CreatableSelect from "react-select/creatable";
import { useDispatch, useSelector } from "react-redux";
import Capsual from "../capsual";
import Title from "../title";
import { Field } from "formik";
import "react-datepicker/dist/react-datepicker.css";
import Webcam from "react-webcam";
import { useDropzone } from "react-dropzone";
import Resizer from "react-image-file-resizer";
import { api } from "../../api/api";
import "react-phone-number-input/style.css";
import PhoneInput, {
  formatPhoneNumber,
  formatPhoneNumberIntl,
  isValidPhoneNumber,
} from "react-phone-number-input";
import { useState } from "react";
import Datetime from "react-datetime";
import "react-datetime/css/react-datetime.css";
import deletenew from "../../assets/images/deletenew.svg";
import moment from "moment";
import {
  getPayRatesType,
  getPayRates,
} from "../../redux/actions/api/apiAction";

const capsualList = [
  {
    id: "1",
    title: "natural-athlete",
  },
  {
    id: "2",
    title: "ifpa-certified-trainer",
  },
  {
    id: "3",
    title: "wellness-coaching",
  },
  {
    id: "4",
    title: "muscle-building",
  },
  {
    id: "5",
    title: "Weight-loss",
  },
  {
    id: "6",
    title: "wellness-coaching",
  },
  {
    id: "7",
    title: "Specialized-in-nutritional-plans",
  },
];
const formSchema2 = Yup.object().shape({
  activeStatus: Yup.string().required("Status is required"),
});

const weekDays = [
  { id: 1, name: "Saturday" },
  { id: 2, name: "Sunday" },
  { id: 3, name: "Monday" },
  { id: 4, name: "Tuesday" },
  { id: 5, name: "Wednesday" },
  { id: 6, name: "Thursday" },
  { id: 7, name: "Friday" },
];

const timesArr = [
  { time: "6:00", value: "6:00" },
  { time: "6:15", value: "6:15" },
  { time: "6:20", value: "6:20" },
  { time: "6:30", value: "6:30" },
  { time: "6:40", value: "6:40" },
  { time: "6:45", value: "6:45" },
  { time: "6:50", value: "6:50" },

  { time: "7:00", value: "7:00" },
  { time: "7:15", value: "7:15" },
  { time: "7:20", value: "7:20" },
  { time: "7:30", value: "7:30" },
  { time: "7:40", value: "7:40" },
  { time: "7:45", value: "7:45" },
  { time: "7:50", value: "7:50" },

  { time: "8:00", value: "8:00" },
  { time: "8:15", value: "8:15" },
  { time: "8:20", value: "8:20" },
  { time: "8:30", value: "8:30" },
  { time: "8:40", value: "8:40" },
  { time: "8:45", value: "8:45" },
  { time: "8:50", value: "8:50" },

  { time: "9:00", value: "9:00" },
  { time: "9:15", value: "9:15" },
  { time: "9:20", value: "9:20" },
  { time: "9:30", value: "9:30" },
  { time: "9:40", value: "9:40" },
  { time: "9:45", value: "9:45" },
  { time: "9:50", value: "9:50" },

  { time: "10:00", value: "10:00" },
  { time: "10:15", value: "10:15" },
  { time: "10:20", value: "10:20" },
  { time: "10:30", value: "10:30" },
  { time: "10:40", value: "10:40" },
  { time: "10:45", value: "10:45" },
  { time: "10:50", value: "10:50" },

  { time: "11:00", value: "11:00" },
  { time: "11:15", value: "11:15" },
  { time: "11:20", value: "11:20" },
  { time: "11:30", value: "11:30" },
  { time: "11:40", value: "11:40" },
  { time: "11:45", value: "11:45" },
  { time: "11:50", value: "11:50" },

  { time: "12:00", value: "12:00" },
  { time: "12:15", value: "12:15" },
  { time: "12:20", value: "12:20" },
  { time: "12:30", value: "12:30" },
  { time: "12:40", value: "12:40" },
  { time: "12:45", value: "12:45" },
  { time: "12:50", value: "12:50" },

  { time: "13:00", value: "13:00" },
  { time: "13:15", value: "13:15" },
  { time: "13:20", value: "13:20" },
  { time: "13:30", value: "13:30" },
  { time: "13:40", value: "13:40" },
  { time: "13:45", value: "13:45" },
  { time: "13:50", value: "13:50" },

  { time: "14:00", value: "14:00" },
  { time: "14:15", value: "14:15" },
  { time: "14:20", value: "14:20" },
  { time: "14:30", value: "14:30" },
  { time: "14:40", value: "14:40" },
  { time: "14:45", value: "14:45" },
  { time: "14:50", value: "14:50" },

  { time: "15:00", value: "15:00" },
  { time: "15:15", value: "15:15" },
  { time: "15:20", value: "15:20" },
  { time: "15:30", value: "15:30" },
  { time: "15:40", value: "15:40" },
  { time: "15:45", value: "15:45" },
  { time: "15:50", value: "15:50" },

  { time: "16:00", value: "16:00" },
  { time: "16:15", value: "16:15" },
  { time: "16:20", value: "16:20" },
  { time: "16:30", value: "16:30" },
  { time: "16:40", value: "16:40" },
  { time: "16:45", value: "16:45" },
  { time: "16:50", value: "16:50" },

  { time: "17:00", value: "17:00" },
  { time: "17:15", value: "17:15" },
  { time: "17:20", value: "17:20" },
  { time: "17:30", value: "17:30" },
  { time: "17:40", value: "17:40" },
  { time: "17:45", value: "17:45" },
  { time: "17:50", value: "17:50" },

  { time: "18:00", value: "18:00" },
  { time: "18:15", value: "18:15" },
  { time: "18:20", value: "18:20" },
  { time: "18:30", value: "18:30" },
  { time: "18:40", value: "18:40" },
  { time: "18:45", value: "18:45" },
  { time: "18:50", value: "18:50" },

  { time: "19:00", value: "19:00" },
  { time: "19:15", value: "19:15" },
  { time: "19:20", value: "19:20" },
  { time: "19:30", value: "19:30" },
  { time: "19:40", value: "19:40" },
  { time: "19:45", value: "19:45" },
  { time: "19:50", value: "19:50" },

  { time: "20:00", value: "20:00" },
  { time: "20:15", value: "20:15" },
  { time: "20:20", value: "20:20" },
  { time: "20:30", value: "20:30" },
  { time: "20:40", value: "20:40" },
  { time: "20:45", value: "20:45" },
  { time: "20:50", value: "20:50" },

  { time: "21:00", value: "21:00" },
  { time: "21:15", value: "21:15" },
  { time: "21:20", value: "21:20" },
  { time: "21:30", value: "21:30" },
  { time: "21:40", value: "21:40" },
  { time: "21:45", value: "21:45" },
  { time: "21:50", value: "21:50" },

  { time: "22:00", value: "22:00" },
  { time: "22:15", value: "22:15" },
  { time: "22:20", value: "22:20" },
  { time: "22:30", value: "22:30" },
  { time: "22:40", value: "22:40" },
  { time: "22:45", value: "22:45" },
  { time: "22:50", value: "22:50" },

  { time: "23:00", value: "23:00" },
  { time: "23:15", value: "23:15" },
  { time: "23:20", value: "23:20" },
  { time: "23:30", value: "23:30" },
  { time: "23:40", value: "23:40" },
  { time: "23:45", value: "23:45" },
  { time: "23:50", value: "23:50" },

  { time: "24:00", value: "00:00" },
  { time: "24:15", value: "00:15" },
  { time: "24:20", value: "00:20" },
  { time: "24:30", value: "00:30" },
  { time: "24:40", value: "00:40" },
  { time: "24:45", value: "00:45" },
  { time: "24:50", value: "00:50" },

  { time: "1:00", value: "1:00" },
  { time: "1:15", value: "1:15" },
  { time: "1:20", value: "1:20" },
  { time: "1:30", value: "1:30" },
  { time: "1:40", value: "1:40" },
  { time: "1:45", value: "1:45" },
  { time: "1:50", value: "1:50" },

  { time: "2:00", value: "2:00" },
  { time: "2:15", value: "2:15" },
  { time: "2:20", value: "2:20" },
  { time: "2:30", value: "2:30" },
  { time: "2:40", value: "2:40" },
  { time: "2:45", value: "2:45" },
  { time: "2:50", value: "2:50" },

  { time: "3:00", value: "3:00" },
  { time: "3:15", value: "3:15" },
  { time: "3:20", value: "3:20" },
  { time: "3:30", value: "3:30" },
  { time: "3:40", value: "3:40" },
  { time: "3:45", value: "3:45" },
  { time: "3:50", value: "3:50" },

  { time: "4:00", value: "4:00" },
  { time: "4:15", value: "4:15" },
  { time: "4:20", value: "4:20" },
  { time: "4:30", value: "4:30" },
  { time: "4:40", value: "4:40" },
  { time: "4:45", value: "4:45" },
  { time: "4:50", value: "4:50" },

  { time: "5:00", value: "5:00" },
  { time: "5:15", value: "5:15" },
  { time: "5:20", value: "5:20" },
  { time: "5:30", value: "5:30" },
  { time: "5:40", value: "5:40" },
  { time: "5:45", value: "5:45" },
  { time: "5:50", value: "5:50" },
];
const DropZone = ({ values, setFieldValue, errors }) => {
  const maxSize = 10485760;
  const onDrop = useCallback((acceptedFiles) => {
    let file = acceptedFiles[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = async (event) => {
        //console.log(event.target.result);
        Resizer.imageFileResizer(
          file,
          300,
          300,
          "PNG",
          100,
          0,
          async (uri) => {
            let data = {
              fileName: acceptedFiles[0].name,
              source: uri,
              folder: "profile",
            };
            var url = await api(`file`, data, "post");
            if (url.data.status === 201) {
              //console.log(uri);
              setFieldValue("image", url.data.data);
            }
          },
          "base64",
          300,
          300
        );
      };
      reader.readAsDataURL(file);
    }
  }, []);
  const {
    isDragActive,
    getRootProps,
    getInputProps,
    isDragReject,
    acceptedFiles,
    rejectedFiles,
  } = useDropzone({
    onDrop,
    minSize: 0,
    maxSize: 10485760,
    accept: "image/*",
  });
  return (
    <div className="upload-profilephoto">
      <div className="file-input" {...getRootProps()}>
        <h6 className="upload-link mb-0">Upload Picture </h6>
        <input {...getInputProps()} />
      </div>
    </div>
  );
};
var phone = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
const WebcamComponent = () => <Webcam />;

export const FormFirstStep = (formikProps) => {
  // console.log("formikProps trainer", formikProps);

  const { errors, touched, values, setFieldValue, isCreate } = formikProps;
  const webcamRef = React.useRef(null);
  const [imgSrc, setImgSrc] = React.useState(null);
  const [phoneNumber, setPhoneNumber] = React.useState(values.phone);
  let trainerAttribute = useSelector((state) => state.trainer.trainerAttribute);
  const payRatesType = useSelector((state) => state.payRoll.payRatesType);
  const payRates = useSelector((state) => state.payRoll.payRates);
  const { gym, gymConfig } = useSelector((state) => state.gym);
  const [takePicture, setTakePicture] = React.useState(false);
  const handleChange = useCallback((inputValue) => setValue(inputValue), []);
  const [value, setValue] = useState();
  const [options, setOptions] = useState([]);
  const [payRatesSelected, setPayRatesSelected] = useState([]);
  const [payRatesRender, setPayRatesRender] = useState([]);
  const [selectedPayRateType, setSelectedPayRateType] = useState("");
  const [selectedPayRate, setSelectedPayRate] = useState("");
  const [isPayRatesSelected, setIsPayRatesSelected] = useState(false);
  const { gymFeaturesObject } = useSelector((state) => state.features);
  console.log({ da: formikProps.dayTimeState });
  const dispatch = useDispatch();
  const [checkedDays, setCheckedDays] = useState({
    Saturday: false,
    Sunday: false,
    Monday: false,
    Tuesday: false,
    Wednesday: false,
    Thursday: false,
    Friday: false,
  });

  const [changer, setChanger] = useState(false);
  const [specialityList, setSpacilityList] = useState([
    {
      id: "1",
      title: " Fitness & Bodybuilding",
    },
    {
      id: "2",
      title: "Martial Arts",
    },
    {
      id: "3",
      title: "Kids Gym",
    },
    {
      id: "4",
      title: " Personal Training",
    },
    {
      id: "5",
      title: "Group Exercise",
    },
    {
      id: "6",
      title: "EMS",
    },
    {
      id: "7",
      title: "Group Exercise",
    },
  ]);

  const [tempTimeStateObject, setTempTimeStateObject] = useState({
    day: null,
    start: null,
    end: null,
    startIndex: null,
    endIndex: null,
  });

  const [deleteTimeState, setDeleteTimeState] = useState({
    day: null,
    timeIndex: null,
  });

  const handleTimeChange = (setFieldValue) => {
    if (tempTimeStateObject.start && tempTimeStateObject.end) {
      const { start, end, day } = tempTimeStateObject;
      const tempDayTime = formikProps.dayTimeState;
      tempDayTime[`${day}`].push({
        start: timesArr[parseInt(start)].value,
        end: timesArr[parseInt(end)].value,
      });
      formikProps.setDayTimeState(tempDayTime);
      setTempTimeStateObject({ start: "", end: "", day: "" });
    }
  };

  React.useEffect(() => {
    if (tempTimeStateObject.start && tempTimeStateObject.end)
      handleTimeChange();
  }, [changer]);

  React.useEffect(() => {
    if (deleteTimeState.day) {
      handleDeleteScheduleTime();
    }
  }, [deleteTimeState]);

  React.useEffect(() => {
    dispatch(getPayRatesType());
  }, [dispatch]);

  React.useEffect(() => {
    const allPayRates = new Set([
      ...payRatesSelected,
      ...formikProps.values.payRates,
    ]);
    setPayRatesRender(Array.from(allPayRates));
    if (payRatesSelected !== formikProps.values.payRates) {
      setPayRatesSelected(formikProps.values.payRates);
    }
  }, [
    payRatesSelected,
    formikProps.values.payRates && formikProps.values.payRates,
  ]);

  React.useEffect(() => {
    setFieldValue("scheduleDays", formikProps.dayTimeState);
    console.log("hhhhheeeeeeeeerrre",formikProps.dayTimeState)
  }, [JSON.stringify(formikProps.dayTimeState)]);

  const handleDeleteScheduleTime = () => {
    const { day: deletedDay, timeIndex: time } = deleteTimeState;
    const timesArr = formikProps.dayTimeState;
    timesArr[`${deletedDay}`].splice(time, 1);
    formikProps.setDayTimeState(timesArr);
    setChanger(!changer);
  };

  const handlePayRateTypesChange = (e) => {
    // console.log(e.target.value, "e.target.value");
    setSelectedPayRateType(e.target.value);
    dispatch(getPayRates(e.target.value));
  };

  const handlePayRateChange = async (e) => {
    const selectedId = parseInt(e.target.value, 10);
    setSelectedPayRate(e.target.value);

    if (!payRatesSelected) {
      setIsPayRatesSelected(false);
    }

    const selectedPayRate = payRates.find(
      (payRate) => payRate.id === selectedId
    );
    if (
      selectedPayRate &&
      !payRatesSelected.some((payRate) => payRate.id === selectedId)
    ) {
      setPayRatesSelected(() => {
        const updatedPayRatesSelected = [selectedPayRate];

        // Move the setFieldValue call inside this callback to ensure it uses updated state
        setFieldValue("payRates", updatedPayRatesSelected);
        return updatedPayRatesSelected; // This returns the new state
      });
    } else {
      console.log("Pay rate already selected or not found");
    }
  };

  const capture = React.useCallback(async () => {
    const imageSrc = webcamRef.current.getScreenshot();
    let data = {
      fileName: "captured",
      source: imageSrc,
      folder: "profile",
    };
    var url = await api(`file`, data, "post");
    if (url.data.status === 201) {
      setFieldValue("image", url.data.data);
    }
    setImgSrc(imageSrc);
    setTakePicture(false);
  }, [webcamRef, setImgSrc]);

  useEffect(() => {
    if (gym?.type == "complex") {
      setSpacilityList([
        {
          id: "8",
          title: "Physiotherapy",
        },
        {
          id: "9",
          title: "One-to-one Stretching",
        },
        {
          id: "10",
          title: "Mobility Training",
        },
        {
          id: "11",
          title: "Balance Training",
        },
        {
          id: "12",
          title: "Postural Correction",
        },
        {
          id: "1",
          title: "Yoga",
        },
        {
          id: "13",
          title: "Mat Pilates",
        },
        {
          id: "14",
          title: "Barrelates",
        },
      ]);
    }
  }, [gym]);

  return (
    <>
      <div className="trainer-info-wrapper info-wrapper border-bottom-1 blk-padding-y">
        <div className="info-title">
          <Title
            title={
              gym.type == "sportClub"
                ? "Coach Info"
                : gym.type == "complex"
                ? "Instructor Info"
                : "Instructor Info"
            }
          />
        </div>
        <div className="profile-image-block blk-padding-y border-bottom-1">
          <div className="profile-image-inner-block d-flex justify-content-center">
            <div className="profile-image-wrapper">
              {takePicture ? (
                <div className="captureimage">
                  <Webcam
                    audio={false}
                    ref={webcamRef}
                    screenshotFormat="image/jpeg"
                  />
                </div>
              ) : (
                <div className="profile-image">
                  <img
                    src={
                      values?.image
                        ? values?.image
                        : require("../../assets/images/no-image_user.jpg")
                    }
                    className="img-fluid img-blk"
                    alt="user"
                  />
                </div>
              )}

              <div className="profile-image-links">
                <div className="links file-input-link">
                  <div
                    className="file-input"
                    onClick={() => {
                      takePicture ? capture() : setTakePicture(true);
                    }}
                  >
                    <h6 className="upload-link mb-0">
                      {!takePicture ? ProfilePicture.takePicture : "Capture"}
                    </h6>
                  </div>
                </div>
                <div className="links file-input-link">
                  <div className="file-input">
                    <DropZone
                      values={values}
                      setFieldValue={setFieldValue}
                      errors={errors}
                    />
                  </div>
                </div>
                <div className="links">
                  <h6
                    className="remove-link mb-0 text-uppercase"
                    onClick={async () => {
                      if (values.image) {
                        // await api(`file`, { url: values.image }, "delete");
                        setFieldValue("image", "");
                      }
                    }}
                  >
                    {ProfilePicture.removePicture}{" "}
                  </h6>
                </div>
              </div>

              {/* </div> */}
            </div>
          </div>
        </div>
        <div className="info trainer-info">
          <Row>
            <Col md={6} className="mb-4 no-margin-on-mobile">
              <FormGroup className="custom-inputs mb-md-0">
                <Field
                  type="text"
                  name="name"
                  id="trainername"
                  maxLength={50}
                  placeholder={WodEditContent.instruction}
                  className={`form-control ${errors.name &&
                    touched.name &&
                    "is-invalid"}`}
                />
                {errors.name && touched.name ? (
                  <div className="invalid-feedback">{`${errors.name}`}</div>
                ) : null}
                <Label for="firstname" className="">
                  {gym.type == "sportClub"
                    ? "Coach Name"
                    : gym.type == "complex"
                    ? "Instructor Name"
                    : "Instructor Name"}
                </Label>
              </FormGroup>
            </Col>
            <Col md={6} className="mb-4 no-margin-on-mobile">
              <FormGroup className="custom-inputs mb-md-0">
                <Field
                  type="text"
                  name="email"
                  id="username"
                  placeholder={WodEditContent.instruction}
                  className={`form-control ${errors.email &&
                    touched.email &&
                    "is-invalid"}`}
                />
                {errors.email && touched.email ? (
                  <div className="invalid-feedback">{`${errors.email}`}</div>
                ) : null}
                <Label> {TrainerEditContent.email}</Label>
              </FormGroup>
            </Col>
            <Col md={6} className="mb-4 no-margin-on-mobile">
              <FormGroup className="custom-inputs mb-md-0">
                <PhoneInput
                  international
                  defaultCountry={
                    JSON.parse(localStorage.getItem("connectToFitGymPanelUser"))
                      .country
                  }
                  value={phoneNumber}
                  placeholder={WodEditContent.instruction}
                  onChange={(value) => {
                    if (value) {
                      setPhoneNumber(value);
                      if (isValidPhoneNumber(value))
                        setFieldValue("phone", value);
                      else setFieldValue("phone", "");
                    }
                  }}
                  className={` ${errors.phone &&
                    touched.phone &&
                    "is-invalid"}`}
                />

                <Label>{TrainerEditContent.phonenumber}</Label>
                {errors.phone && touched.phone ? (
                  <div className="invalid-feedback">{`${errors.phone}`}</div>
                ) : null}
              </FormGroup>
            </Col>
            <Col md={6} className="mb-4 no-margin-on-mobile">
              <FormGroup className="custom-inputs mb-md-0 ">
                <Datetime
                  value={values?.dob}
                  onChange={(date) => {
                    if (date) setFieldValue("dob", date);
                  }}
                  dateFormat="DD/MM/YYYY"
                  timeFormat={false}
                  inputProps={{ placeholder: "Select or type a date" }}
                  closeOnSelect
                  renderYear={(props, year) => (
                    <option
                      {...props}
                      style={{ fontSize: "12px", cursor: "pointer", margin: 5 }}
                    >
                      {year}
                    </option>
                  )}
                />
                <small style={{ color: "#4D4467" }}>
                  {" "}
                  Date format is DD/MM/YYYY
                </small>

                {errors.DOB && touched.DOB ? (
                  <div className="invalid-feedback">{`${errors.DOB}`}</div>
                ) : null}
                <Label>{MembersInfoEdit.date}</Label>
              </FormGroup>
            </Col>
            {gymConfig?.payroll?.enabled && (
              <>
                <Col md={6} className="mb-4 no-margin-on-mobile">
                  <FormGroup className="custom-inputs mb-md-0">
                    <Field
                      onChange={handlePayRateTypesChange}
                      // required={payRatesSelected.length < 1}
                      value={selectedPayRateType}
                      as="select"
                      name="payratesType"
                      id="payratesType"
                      className={`form-control ${payRatesSelected.length < 1 &&
                        isPayRatesSelected &&
                        "is-invalid"}`}
                    >
                      <option value="">Select an option</option>
                      {payRatesType.length &&
                        payRatesType.map((type) => {
                          return <option value={type.id}>{type.name}</option>;
                        })}
                    </Field>
                    <Label>Main pay rate type</Label>
                  </FormGroup>
                </Col>
                {console.log({ values })}
                <Col md={6} className="mb-4 no-margin-on-mobile">
                  <FormGroup className="custom-inputs mb-md-0">
                    <Field
                      onChange={handlePayRateChange}
                      // required={payRatesSelected.length}
                      value={selectedPayRate}
                      as="select"
                      name="payrate"
                      id="payrate"
                      className={`form-control ${payRatesSelected.length < 1 &&
                        isPayRatesSelected &&
                        "is-invalid"}`}
                    >
                      <option value="">Select an option</option>
                      {payRates &&
                        payRates.map((payRate) => {
                          return (
                            <option value={payRate.id}>
                              {payRate.payrateName}
                            </option>
                          );
                        })}
                    </Field>
                    {payRatesSelected.length < 1 && isPayRatesSelected ? (
                      <div className="invalid-feedback">
                        Please select at least one pay rate
                      </div>
                    ) : null}
                    <Label>Sub pay rate type</Label>
                  </FormGroup>
                </Col>
                <Col md={6} className="mb-4 no-margin-on-mobile">
                  <div className="d-flex flex-wrap" style={{ gap: "0.5rem" }}>
                    {payRatesRender.length > 0 &&
                      payRatesRender.map((payRate, i) => {
                        return (
                          <div
                            style={{
                              background: "#F6A51F",
                              borderRadius: "0.25rem",
                              display: "flex",
                              padding: "0.7rem 1rem",
                              color: "white",
                              gap: "1rem",
                            }}
                          >
                            <p>{payRate.payrateName}</p>
                            <img
                              style={{ cursor: "pointer" }}
                              src={deletenew}
                              onClick={() => {
                                setPayRatesSelected(
                                  payRatesSelected.filter(
                                    (payRate, index) => index !== i
                                  )
                                );
                                setPayRatesRender(
                                  payRatesRender.filter(
                                    (payRate, index) => index !== i
                                  )
                                );
                                setFieldValue(
                                  "payRates",
                                  payRatesSelected.filter(
                                    (payRate, index) => index !== i
                                  )
                                );
                              }}
                            />
                          </div>
                        );
                      })}
                  </div>
                </Col>
              </>
            )}
            {
              (gymConfig?.manageMemberships?.classMemberships?.enabled||gymConfig?.manageMemberships?.appointmentMemberships?.enabled||gymConfig?.manageMemberships?.workshopAndCoursesMemberships?.enabled )&& (
                <Col md={6} className="mb-4 no-margin-on-mobile">
                  <FormGroup className="custom-inputs mb-md-0">
                    <Field
                      onChange={(e)=>setFieldValue("serviceType",e.target.value)}
                      // required={payRatesSelected.length < 1}
                      value={values.serviceType}
                      as="select"
                      name="serviceType"
                      id="serviceType"
                      className={`form-control`}
                    >
                      <option value={null}>Select services type</option>
                      {gymConfig?.manageMemberships?.classMemberships?.enabled  &&(
                        <option value={"class"}>Class/Group Sessions</option>
                        )}
                      {gymConfig?.manageMemberships?.appointmentMemberships?.enabled  &&(
                        <option value={"pt"}>Appointment/Personal Training</option>
                        )}
                      {gymConfig?.manageMemberships?.workshopAndCoursesMemberships?.enabled  &&(
                        <option value={"workshop"}>Workshop</option>
                        )}      
                    </Field>
                    <Label>Service Type</Label>
                  </FormGroup>
                </Col>
             )} 
            <Col md={12} className={`mt-3 ml-2 ${gymConfig?.manageInstructors?.enabled && !gymConfig.manageInstructors.addInstructorAsMember ? 'disabled-card' : ''}`}>
              <div className="specialities-inner-block">
                <div className="specialities-selected">
                  <div className="specialities-list">
                    <div className="capsual-list">
                      <div className="selction-box">
                        <ul className="priviledge-checkbox-list-block">
                          <li className="priviledge-checkbox-element">
                            <FormGroup className="checkboxes-list" check>
                              <Label check className="container-blk">
                                <Input
                                  type="checkbox"
                                  id={values.addTrainerAsMember}
                                  onChange={(e) => {
                                    if (e.target.checked) {
                                      setFieldValue("addTrainerAsMember", true);
                                    } else {
                                      setFieldValue(
                                        "addTrainerAsMember",
                                        false
                                      );
                                    }
                                  }}
                                />{" "}
                                Add Instructor As Member
                                <span className="checkmark"></span>
                              </Label>
                            </FormGroup>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </div>
      <div className="trainer-gender-default-wrapper border-bottom-1 blk-padding-y">
        <div className="info-title">
          <Title title={TrainerEditContent.genderTitle} />
        </div>
        <div className="status-inner-block">
          <div className="status-inner-block">
            <div className="subscription-plan-list-element">
              <div className="">
                <div
                  className="form-check form-check-inline custom-btn-radio no-margin-on-mobile"
                  onChange=""
                >
                  <Field
                    type="radio"
                    name="gender"
                    id="inlineRadio200"
                    value="M"
                    className="form-check-input no-padding"
                  />

                  <label
                    className="form-check-label label-blk"
                    for="inlineRadio200"
                  >
                    Male
                  </label>
                </div>
              </div>
            </div>
            <div className="subscription-plan-list-element">
              <div className="">
                <div
                  className="form-check form-check-inline custom-btn-radio no-margin-on-mobile"
                  checked
                  onChange=""
                >
                  <Field
                    type="radio"
                    name="gender"
                    id="inlineRadio201"
                    value="F"
                    className="form-check-input"
                  />
                  <label
                    className="form-check-label label-blk"
                    for="inlineRadio201"
                  >
                    Female
                  </label>
                </div>
              </div>
            </div>
          </div>
          {errors.gender && touched.gender ? (
            <div
              className="invalid-feedback"
              style={{ display: "block" }}
            >{`${errors.gender}`}</div>
          ) : null}
        </div>
      </div>
      <div className="status-wrapper  border-bottom-1 blk-padding-y">
        <div className="info-title">
          <Title title="Live training" />
        </div>
        <div className="status-inner-block">
          <div className="time-select-box d-inline-block">
            <div className="d-flex align-items-center">
              <div className="switch-wrapper line-switch">
                <Input
                  type="checkbox"
                  id="switchBox203"
                  className="switch-input"
                  checked={values.canLive}
                  onChange={(e) => {
                    setFieldValue("canLive", !values.canLive);
                  }}
                />
                <Label for="switchBox203" className="switch-label"></Label>
              </div>
            </div>
          </div>
          <div className="d-inline-block">
            {values.canLive ? (
              <h3 className="ctf-tx-fifth success">Enabled</h3>
            ) : (
              <h3 className="ctf-tx-fifth text-danger">Disabled</h3>
            )}
          </div>
        </div>
      </div>
      <div className="trainer-gender-default-wrapper border-bottom-1 blk-padding-y">
        <div className="info-title">
          <Title
            title={
              gym.type == "sportClub"
                ? "Coach Status"
                : gym.type == "complex"
                ? "Instructor status"
                : "Instructor status"
            }
          />
        </div>
        <div className="status-inner-block">
          <div className="status-inner-block">
            <div className="subscription-plan-list-element">
              <div className="">
                <div
                  className="form-check form-check-inline custom-btn-radio no-margin-on-mobile"
                  onChange=""
                >
                  <Field
                    type="radio"
                    name="activeStatus"
                    id="inlineRadio204"
                    value="ACTIVE"
                    className="form-check-input no-padding"
                  />
                  <label
                    className="form-check-label label-blk"
                    for="inlineRadio204"
                  >
                    Active
                  </label>
                </div>
              </div>
            </div>
            <div className="subscription-plan-list-element">
              <div className="">
                <div
                  className="form-check form-check-inline custom-btn-radio no-margin-on-mobile"
                  checked
                  onChange=""
                >
                  <Field
                    type="radio"
                    name="activeStatus"
                    id="inlineRadio205"
                    value="HIDDEN"
                    className="form-check-input"
                  />
                  <label
                    className="form-check-label label-blk"
                    for="inlineRadio205"
                  >
                    Hidden
                  </label>
                </div>
              </div>
            </div>
            <div className="subscription-plan-list-element">
              <div className="">
                <div
                  className="form-check form-check-inline custom-btn-radio"
                  checked
                  onChange=""
                >
                  <Field
                    type="radio"
                    name="activeStatus"
                    id="inlineRadio206"
                    value="FREEZED"
                    className="form-check-input no-padding"
                  />
                  <label
                    className="form-check-label label-blk"
                    for="inlineRadio206"
                  >
                    Freezed
                  </label>
                </div>
              </div>
            </div>
          </div>
          {errors.activeStatus && touched.activeStatus ? (
            <div
              className="invalid-feedback"
              style={{ display: "block" }}
            >{`${errors.activeStatus}`}</div>
          ) : null}
        </div>
      </div>
      <div className="additional-wrapper status-wrapper border-bottom-1 blk-padding-y">
        <div className="info-title">
          <Title title={TrainerEditContent.additionalTitle} />
        </div>
        <div className="additional-info-title info">
          <Row>
            <Col md={12}>
              <FormGroup className="custom-inputs mb-md-0">
                <CreatableSelect
                  isClearable={false}
                  value=""
                  isDisabled={values.qualifications.length >= 8 ? true : false}
                  className="form-control multi-select-search-block p-0"
                  placeholder={WodEditContent.instruction}
                  // options={options}
                  onChange={handleChange}
                  onCreateOption={(inputValue) => {
                    const newValue = {
                      value: inputValue,
                      label: inputValue,
                    };

                    if (!values.qualifications.includes(inputValue)) {
                      setOptions([...options, newValue]);
                      setFieldValue("qualifications", [
                        ...values.qualifications,
                        inputValue,
                      ]);
                    }
                    setValue(newValue);
                  }}
                />
                <Label for="firstname" className="">
                  {TrainerEditContent.qualification}
                </Label>
              </FormGroup>
            </Col>
          </Row>
        </div>
        <div className="blk-padding-y">
          <Row>
            <Col md={4}>
              <div className="input-remain-content">
                <p
                  className={`ctf-tx-secondary ${
                    values.qualifications.length >= 8 ? "text-success" : null
                  }`}
                >
                  {TrainerEditContent.numberNotice}
                </p>
              </div>
            </Col>
          </Row>
        </div>
        <div className="additional-inner-block">
          <div className="additional-selected">
            <div className="additional-list">
              <div className="capsual-list">
                {values.qualifications.map((value, index) => {
                  return (
                    <Capsual
                      title={value}
                      delete={true}
                      deleteItem={() => {
                        let array = values.qualifications || [];
                        let index = array.indexOf(value);
                        if (index > -1) {
                          array.splice(index, 1);
                          setFieldValue("qualifications", array);
                        }
                      }}
                    />
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="specialities-wrapper status-wrapper border-bottom-1 blk-padding-y">
        <div className="info-title">
          <Title title={TrainerEditContent.specialityTitle} />
        </div>
        <div className="specialities-inner-block">
          <div className="specialities-selected">
            <div className="specialities-list">
              <div className="capsual-list">
                <div className="selction-box">
                  <ul className="priviledge-checkbox-list-block">
                    {specialityList.map((value, index) => {
                      return (
                        <li className="priviledge-checkbox-element">
                          <FormGroup className="checkboxes-list" check>
                            <Label check className="container-blk">
                              <Input
                                type="checkbox"
                                id={value.id}
                                checked={values.trainerAttributes.includes(
                                  parseInt(value.id)
                                )}
                                onChange={(e) => {
                                  if (e.target.checked) {
                                    let data = values.trainerAttributes;
                                    data.push(parseInt(value.id));
                                    setFieldValue("trainerAttributes", data);
                                  } else {
                                    let data = values.trainerAttributes;
                                    let index = data.indexOf(
                                      parseInt(value.id)
                                    );
                                    data.splice(index, 1);
                                    setFieldValue("trainerAttributes", data);
                                  }
                                }}
                              />{" "}
                              {value.title}
                              <span className="checkmark"></span>
                            </Label>
                          </FormGroup>
                        </li>
                      );
                    })}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="selction-box">
        <Row className="mt-3 mx-0">
          <Title
            title={TrainerEditContent.scheduling}
            subtitle="(Leave empty for open schedule)"
            titlestyle="pb-2"
          />
          <ul className="schedule-checkbox-list-block mt-2">
            {weekDays.map((value, index) => {
              const times = formikProps.dayTimeState;
              const days = checkedDays;
              return (
                <Row
                  className={`schedule-row ${value.name}`}
                  style={{
                    backgroundColor: value.id % 2 === 0 ? "#f5f7f8" : "",
                  }}
                >
                  <li className="schedule-checkbox-element">
                    <FormGroup className="schedule-checkboxes-list" check>
                      <Label check className="container-blk">
                        <Input
                          type="checkbox"
                          id={value.id}
                          onChange={(e) => {
                            if (e.target.checked) {
                              days[`${value.name}`] = true;
                            } else {
                              days[`${value.name}`] = false;
                              times[`${value.name}`] = [];
                            }
                            setCheckedDays(days);
                            formikProps.setDayTimeState(times);

                          }}
                        />{" "}
                        {value.name}
                        <span className="checkmark"></span>
                      </Label>
                    </FormGroup>
                    <span
                      className="selected-times-outer-container"
                      style={{
                        display: "grid",
                        gridTemplateColumns: "repeat(2,0.1fr)",
                      }}
                    >
                      <span className="selected-times-container ">
                        {formikProps.dayTimeState[`${value.name}`].map(
                          (time, timeIndex) => {
                            return (
                              <span className="time-card-container">
                                <span className="time-card-inner-container">
                                  <span className="time-card-texts">
                                    {time.start} - {time.end}
                                  </span>
                                  <span
                                    className="times-card-delete"
                                    onClick={() => {
                                      setDeleteTimeState({
                                        day: value.name,
                                        timeIndex: timeIndex,
                                      });
                                    }}
                                  >
                                    <img src={deletenew} />
                                  </span>
                                </span>
                              </span>
                            );
                          }
                        )}
                        {days[`${value.name}`] && (
                          <FormGroup className="custom-inputs select-box mb-md-0 times-container">
                            <Input
                              type="select"
                              className={` times-dropdown time-from `}
                              name={`times-${value.name}-from`}
                              id={`${value.name}-times`}
                              value={
                                tempTimeStateObject.day === value.name
                                  ? tempTimeStateObject.start
                                  : ""
                              }
                              placeholder={"Trainer"}
                              onChange={(e) => {
                                setTempTimeStateObject({
                                  ...tempTimeStateObject,
                                  start: e.target.value,
                                  day: `${value.name}`,
                                });
                                setChanger(!changer);
                              }}
                            >
                              <option value="">From</option>
                              {tempTimeStateObject.end
                                ? timesArr
                                    .slice(0, tempTimeStateObject.end)
                                    .map((time, timeIndex) => {
                                      return (
                                        <option
                                          key={time.value}
                                          value={timesArr.indexOf(time)}
                                        >
                                          {time.time}
                                        </option>
                                      );
                                    })
                                : timesArr.map((time, timeIndex) => {
                                    return (
                                      <option
                                        key={time.value}
                                        value={timeIndex}
                                      >
                                        {time.time}
                                      </option>
                                    );
                                  })}
                            </Input>
                            <Input
                              type="select"
                              placeholder="To"
                              className={`form-control times-dropdown time-to`}
                              name={`times-${value.name}-to`}
                              value={tempTimeStateObject.end}
                              id={`${value.name}-times `}
                              onChange={(e) => {
                                setTempTimeStateObject({
                                  ...tempTimeStateObject,
                                  end: e.target.value,
                                  day: `${value.name}`,
                                });
                                setChanger(!changer);
                              }}
                            >
                              <option value="">To</option>
                              {tempTimeStateObject.start
                                ? timesArr
                                    .slice(
                                      parseInt(tempTimeStateObject.start) + 1
                                    )
                                    .map((time, timeIndex) => {
                                      return (
                                        <option
                                          key={time.value}
                                          value={timesArr.indexOf(time)}
                                        >
                                          {time.time}
                                        </option>
                                      );
                                    })
                                : timesArr.map((time, timeIndex) => {
                                    return (
                                      <option
                                        key={time.value}
                                        value={timeIndex}
                                      >
                                        {time.time}
                                      </option>
                                    );
                                  })}
                            </Input>
                          </FormGroup>
                        )}
                      </span>
                    </span>
                  </li>
                </Row>
              );
            })}
          </ul>
        </Row>
      </div>
    </>
  );
};
